// extracted by mini-css-extract-plugin
export default {"root":"RsnsMLVvMB_3fNnB4C0f","active":"yOpdvwy2g9nWZMD8V88P","image":"dI3pcWB1N7ehNf56Zw2D","placeHolderShimmer":"NqT4a8RALYoDpfGS2k7l"};